import { selectors } from './carousel';
window.refreshSections = function (sectionsToRefresh) {
  var _this = this;
  var sections = sectionsToRefresh.map(function (section) {
    return section.id;
  });
  fetch("?sections=".concat(sections), {}).then(function (response) {
    return response.text();
  }).then(function (state) {
    var parsedState = JSON.parse(state);
    _this.renderContents({
      sectionsToRefresh: sectionsToRefresh,
      sections: parsedState
    }, false);
    // only load carousel when .swiper__parent is present
    var carouselNodes = document.querySelectorAll(selectors.parent);
    if (carouselNodes.length > 0) {
      import(/* webpackChunkName: "carousel-import" */'./carousel').then(function (module) {
        return module.carouselInit();
      });
    }
  })["catch"](function () {
    // console.log('catching')
  });
};
window.renderContents = function (parsedState) {
  var _this2 = this;
  parsedState.sectionsToRefresh.forEach(function (section) {
    if (section.dynamic) {
      document.getElementById('shopify-section-' + section.id).innerHTML = _this2.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    } else {
      document.getElementById(section.id).innerHTML = _this2.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }
    if (section.id === 'cart-drawer') {
      document.getElementById(section.id).setupCloseButton();
    }
  });
};
window.getSectionInnerHTML = function (html) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.shopify-section';
  // console.log('getting inner html')
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};